// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c2de0376] .el-dialog__body {\n  padding: 10px 10px;\n  height: 350px;\n  overflow: auto;\n}\n.block[data-v-c2de0376] {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  color: #999;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.el-form-item--mini.el-form-item[data-v-c2de0376] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
